<template>
  <v-form v-model="valid" v-on:submit.prevent='submitForm(formData)'>
    <div class="title mb-3">
      <v-text-field prepend-icon="mdi-account" :rules="[required('email')]" data-vv-name="email" v-model="formData.email" label="Email"/>
      <v-text-field prepend-icon="mdi-lock" :rules="[required('password')]" data-vv-name="password" :type="getPasswordType"
                    v-model="formData.password" label="Password" :append-icon="getTogglePassword"
                    @click:append="showPasswordText = !showPasswordText"/>
      <v-checkbox color="primary" v-model="formData.remember" label="Remember me"></v-checkbox>
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn type='submit' :disabled="!valid || loading" large class="primary">
        <span v-if="!loading">{{ buttonText }}</span>
        <v-progress-circular v-if="loading" indeterminate color="loadng"/>
      </v-btn>
    </v-card-actions>
    <div><span class="error--text">{{errorMessage}}</span></div>
  </v-form>
</template>

<script>
export default {
  name: 'UserAuthForm',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    passwordToggle: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Log in'
    },
    submitForm: {
      type: Function,
      required: true
    }
  },

  data: function () {
    return {
      valid: false,
      showPasswordText: false,
      formData: {
        remember: '',
        email: '',
        password: ''
      },
      required (propertyType) {
        return v => ((v && v.length > 0) || `You must input a ${propertyType}`)
      }
    }
  },

  computed: {
    getPasswordType: function () {
      if (this.noPasswordToggle) {
        return 'password'
      } else {
        return this.showPasswordText ? 'text' : 'password'
      }
    },
    getTogglePassword: function () {
      if (!this.passwordToggle) {
        return ''
      } else {
        return this.showPasswordText ? 'mdi-eye' : 'mdi-eye-off'
      }
    }

  }
}
</script>

<style scoped>

</style>
